import './merchandising.css';

/**
 * Merchandising banner template
 * @param {object} item
 * @param {string} item.style_code - default: `green`
 *
 * @param {object[]} item.links
 * @param {string} item.links.title
 * @param {string} item.links.text
 * @param {string} item.links.target
 * @param {string} item.links.href
 * @param {string} item.links.options
 *
 * @param {object[]} item.titles
 * @param {string} item.titles.title
 * @param {string} item.titles.content
 *
 * @param {object[]} item.texts
 * @param {string} item.texts.text
 *
 * @param {object[]} item.images
 * @param {string} item.images.src
 * @param {string} item.images.alt
 * @return {string} - Formatted HTML
 */
export const merchandisingBannerTpl = function (item) {
  let htmlFinal = '';

  if (item) {
    const colorStyle = !!item.style_code ? item.style_code : 'green';

    let htmlLink = '';
    let styleParam = '';

    if (item.links.length && item.links[0].text !== '') {
      //-- last text is popin text if link is lightview
      const isPopin = item.links[0].target === 'lightview';

      if (item.links[0].href) {
        htmlLink = `
        <a class="mainLink merchOffer-link${isPopin ? ' js-merchOffer-fancybox' : ''}" title="${item.links[0].title}" href="${isPopin ? '#' : item.links[0].href}" ${!item.links[0].target && item.links[0].target === 'lightview' ? 'target=' + item.links[0].target : ''}  ${isPopin ? 'data-type="inline" data-src="#merchOffer-fancybox" data-aftershow_init="search:resultList:merchFancyOpen"' : ''}>${item.links[0].text}</a>`;
      }

      if (isPopin) {
        const hasPopinImg = item.images.length === item.texts.length;
        const imgPopin = item.images.length === item.texts.length ? item.images[item.images.length - 1] : item.images.length ? item.images[0] : false;
        const styleOption = !!item.links[0].options ? item.links[0].options : false;

        let htmlImgFancy = '';

        if (styleOption && !!styleOption.length) {
          JSON.parse(styleOption, (key, value) => {
            styleParam += key !== '' ? key + ':' + value + ';' : '';
          });
        }

        if (imgPopin) {
          const photo = !!imgPopin.ratioSrc ? imgPopin.ratioSrc : false;
          const srcDesktop = photo && Object.keys(imgPopin.ratioSrc).length ? (photo['X-Small'] !== null ? photo['X-Small'] : '') : imgPopin.src;
          const altImg = !!imgPopin.alt ? imgPopin.alt : item.titles[0].title;

          htmlImgFancy = hasPopinImg ?
            `<div class="merchOffer-fancybox-img"><img src="${srcDesktop}" alt="${altImg}" /></div>` :
            `<div class="merchOffer-fancybox-img merchOffer-visual"><picture><img src="${srcDesktop}" alt="${altImg}" /></picture></div>`;
        }

        htmlLink += `
      <div style="display:none;${styleParam}" id="merchOffer-fancybox" class="${hasPopinImg ? 'merchOffer-fancybox-hasImg' : `merchOffer-${colorStyle}`}">
        ${htmlImgFancy}
        <p class="merchOffer-fancybox-title">${item.titles[0].title}</p>
        <div class="merchOffer-fancybox-text js-merchOffer-customScroll">${!!item.texts[0].text ? item.texts[0].text : ''}</div>
      </div>`;
      }
    }

    //-- different design according to nb blocks
    const nbBlock = item.texts.length;

    htmlFinal = `
  <div class="merchOffer${nbBlock > 1 ? ' merchOffer-multiple' : ' merchOffer-single'} merchOffer-${colorStyle} themBorderColor" id="js-merchOffer">
    <div class="merchOffer-container">
      <div class="merchOffer-inner swiper-container">
        <div class="merchOffer-slider swiper js-swiper js-merchOffer-slider" data-slider="{'slidesPerView': 1, 'spaceBetween': 12, 'breakpoints': {'768': {'slidesPerView': 2}, '1024': {'slidesPerView': 3, 'spaceBetween': 20}}}">
          <div class="swiper-wrapper">`;

    for (let i = 0; i < nbBlock; i++) {
      htmlFinal += `
          <div class="merchOffer-box${i === 0 ? ' merchOffer-box--first' : ''} swiper-slide api_heightEqualizer-row">`;

      if (item.images.length > i) {
        const srcDesktop = item.images.length ? item.images[i].src : '';

        if (srcDesktop !== '') {
          htmlFinal += `
            <div class="merchOffer-visual">
              <picture>
                <img src="${srcDesktop}" alt="${item.images[i].alt}" itemprop="image" class="lazy">
                <noscript>
                  <img src="${srcDesktop}" alt="${item.images[i].alt}" />
                </noscript>
              </picture>
            </div>`;
        }
      }

      htmlFinal += `
            <div class="merchOffer-content r-Grid-cell">
              ${item.titles.length > i && item.titles[i] && !!item.titles[i].title && item.titles[i].title !== 'no_title' ? `
              <p class="merchOffer-title">${item.titles[i].title}</p>` : ''}
              <div class="merchOffer-text">
                ${item.texts.length > i ? item.texts[i].text.replace(/&nbsp;/g, ' ') : ''}
              </div>
              ${nbBlock === 1 ? htmlLink : ''}
            </div>
          </div>`;
    }

    htmlFinal += `
          </div>
        </div>
        ${nbBlock > 3 ? '<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>' : ''}
      </div>
    </div>
    ${nbBlock > 1 ? `<div class="merchOffer-link-container">${htmlLink}</div>` : ''}
  </div>`;
  }

  return htmlFinal;
};